import * as React from "react";
import styled from "styled-components";
import { InfoIcon } from "../Icons";
import { Tooltip } from "../Tooltip/Tooltip";

const StyledSettingsIcon = styled.span`
    margin-left: 2px;
    position: relative;
    top: 2px;
`;

export const SettingsInformation = (): JSX.Element => (
    <StyledSettingsIcon>
        <Tooltip direction="north" text="Die Stilprüfung können Sie in den Einstellungen anpassen.">
            <InfoIcon />
        </Tooltip>
    </StyledSettingsIcon>
);

